import { AfterViewInit, Component, ViewChild, computed } from '@angular/core';
import { SvgComponent } from '@app/components/svg/svg.component';
import { XMLElementBaseComponent } from '../base';
import { environment } from '@env';

@Component({
  selector: 'app-vw-wd-image',
  imports: [SvgComponent],
  standalone: true,
  template: `
    <div class="w-full rounded-lg border border-gray-300 max-lg:min-w-[calc(100dvw-2rem)] lg:w-[60dvw]">
      <app-svg
        #svgComponent
        [url]="imgSrc()"
        [padding]="40"
        [withZoom]="true"
        svgType="vw"
        class="block h-[60dvh] max-h-[60dvh] w-full max-w-full lg:max-h-[80dvh]" />
    </div>
  `,
})
export class WDImageComponent extends XMLElementBaseComponent implements AfterViewInit {
  @ViewChild('svgComponent') svgComponent: SvgComponent | undefined;

  ngAfterViewInit() {
    if (this.svgComponent) {
      this.registerSvg(this.svgComponent);
    }
  }

  imgSrc = computed(() => {
    if (!environment.api.url || !this.data.vehicleId || !this.data.name) return undefined;

    const baseUrl = environment.api.url;
    const params = `subject=SLP&vehicleId=${this.data.vehicleId}&imageId=${this.data.name}`;

    switch (this.provider) {
      case 'volkswagen':
        return `${baseUrl}/rmi/vw/proxy-image?${params}`;
      case 'skoda':
        return `${baseUrl}/rmi/skoda/proxy-image?${params}`;
      case 'seat':
        return `${baseUrl}/rmi/seat/proxy-image?${params}`;
      case 'audi':
        return `${baseUrl}/rmi/audi/proxy-image?${params}`;
      default:
        return `${baseUrl}/rmi/vw/proxy-image?${params}`;
    }
  });
}
